import { fetchAsObservable } from 'fetcher!sofe'

export function allowDevice(allow = false, mfaToken) {
  return fetchAsObservable(`/mfa-devices/${mfaToken}`, {
    body: { allowDevice: allow },
    method: 'post'
  })
}
